module.exports = __webpack_public_path__ + "fonts/Simple-Line-Icons.0bbfc705.woff";